import { useAuth } from 'react-oidc-context';
import TractionService from './traction-service';
import { useEffect, useMemo } from 'react';

/**
 * @description Use traction service
 * @return {TractionService}
 */
export const useTractionService = (): TractionService => {
  const auth = useAuth();

  const service = new TractionService(auth?.user?.access_token || '');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const tractionService = useMemo(() => service, []);

  useEffect(() => {
    if (auth?.user?.access_token && tractionService.getToken() !== auth.user.access_token) {
      tractionService.refreshToken(auth.user.access_token);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.user?.access_token, service]);

  return tractionService;
};
